import React, { FC, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { setAccessToken } from "../../services/LocalStorage";

const FinishLegalPlace: FC = () => {
  const navigate = useNavigate();
  const params: any = useParams();
  const { token } = params;

  useEffect(() => {
    if (token) {
      setAccessToken(token)
        .then(() => navigate("/company"))
        .catch(() => navigate("/"));
    } else {
      navigate("/");
    }
  }, [token]);

  return <></>;
};
export default FinishLegalPlace;
